import { css } from '@emotion/react';
import { CARET_SIZE } from './constants';
import { Animation, Button, Colors, Icon, Link, Typography, } from '@zapier/design-system';
import { isolateComponent, labelStyles, withModifier, } from '@zapier/style-encapsulation';
import { emitUserInteractionEvent } from '../../utils/avroEvents';
import { UNIVERSAL_TOPBAR_HEIGHT } from '../../constants';
import { useUniversalNavContext } from '../../hooks';
import { MegaMenu } from './OutOfAppTopbar/MegaMenu';
const Styles = labelStyles('UniversalTopbarLink', {
    root: (isMenuOnly) => [
        css(Object.assign(Object.assign({ paddingRight: isMenuOnly ? `${CARET_SIZE + 18}px` : 18, display: 'flex', alignItems: 'center', color: Colors.neutral700 }, Typography.paragraph3), { '&:hover, &:focus, &:focus-within': {
                fontWeight: 600,
            }, '&[data-position="actions-menu"]': {
                paddingRight: 0,
            } })),
    ],
    link: (isMenuOnly) => [
        css(Object.assign(Object.assign({ color: Colors.inherit, display: 'flex', flexDirection: 'column', alignItems: 'center', height: UNIVERSAL_TOPBAR_HEIGHT, lineHeight: `${UNIVERSAL_TOPBAR_HEIGHT}px` }, Typography.base), { cursor: 'pointer', textDecoration: 'none', position: 'relative', '&:visited': {
                color: 'inherit',
            }, '&:focus': {
                outline: 'none',
            }, '&:focus-within > span': {
                '&::before': {
                    backgroundColor: Colors.neutral300,
                },
            }, '&::after': {
                content: 'attr(data-text)',
                height: 0,
                visibility: 'hidden',
                overflow: 'hidden',
                userSelect: 'none',
                pointerEvents: 'none',
                fontWeight: 600,
            }, '&::before': {
                content: '""',
                height: 6,
                width: 0,
                fontWeight: 600,
                position: 'absolute',
                color: Colors.zapier,
                borderBottom: '6px solid',
                bottom: 0,
                left: 0,
                zIndex: 10,
                transition: `width 200ms ${Animation.transitionTimingFunction}`,
            }, '&[data-selected="true"]': {
                '&::before': {
                    width: isMenuOnly ? 'calc(100% + 17px)' : '100%',
                },
            } })),
    ],
    linkInner: (isMenuOnly) => css({
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        transformStyle: 'preserve-3d',
        height: '100%',
        position: 'relative',
        '&::before': {
            content: '""',
            position: 'absolute',
            top: 20,
            right: isMenuOnly ? '-28px' : '-10px',
            bottom: 20,
            left: '-10px',
            transform: 'translateZ(-1px)',
            borderRadius: 4,
            height: 32,
        },
    }),
    caret: (isMenuOpen) => [
        css({
            transition: Animation.transitionValue,
            position: 'absolute',
            top: CARET_SIZE - 1,
            right: `-${CARET_SIZE}px`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: CARET_SIZE,
            width: CARET_SIZE,
        }),
        isMenuOpen &&
            withModifier('menu-open', {
                transform: 'rotate(-180deg)',
            }),
    ],
});
export const UniversalTopbarLink = ({ ariaControls, ariaLabel, children, isButton = false, isMenuOpen, navigationItem, onCloseMenu, position, role, toggleMenu, icon, onClick, }) => {
    var _a;
    const { getFullyQualifiedURL } = useUniversalNavContext();
    const sanitizedId = ariaControls === null || ariaControls === void 0 ? void 0 : ariaControls.replace(/[^\w]/g, '');
    const isMenuOnly = navigationItem.variant !== 'link';
    const handleEvent = (eventType) => {
        let eventMessage = '';
        if (eventType === 'click') {
            eventMessage = `${isMenuOpen ? 'Closing' : 'Opening'} UniversalLayout DynamicTopBar: ${isMenuOnly ? children : navigationItem.href}`;
        }
        else {
            eventMessage = `UniversalLayout DynamicTopBar: ${isMenuOnly ? children : navigationItem.href}`;
        }
        emitUserInteractionEvent({
            event_action: eventType,
            option_selected: eventMessage,
        });
    };
    const WrapperElement = position === 'actions-menu' ? 'span' : 'li';
    if (navigationItem.variant === 'link') {
        return (isolateComponent(WrapperElement, { css: Styles.root(false), "data-position": position, "data-testid": "topbar-link", role: role }, isButton ? (isolateComponent(Button, Object.assign({ href: getFullyQualifiedURL(navigationItem.href), color: (_a = navigationItem.color) !== null && _a !== void 0 ? _a : 'secondary', size: "xsmall" }, (onClick && { onClick })), children)) : (isolateComponent(Link, { color: null, css: Styles.link(false, isButton), "data-text": navigationItem.text + (icon ? '-----' : ''), "data-selected": false, href: getFullyQualifiedURL(navigationItem.href), target: navigationItem.target, onClick: () => {
                handleEvent('click');
                if (toggleMenu && !navigationItem.href)
                    toggleMenu();
            }, onMouseEnter: () => handleEvent('hover'), "aria-controls": sanitizedId, "aria-expanded": undefined, ariaLabel: ariaLabel },
            isolateComponent("span", { css: Styles.linkInner(false) },
                icon && isolateComponent(Icon, { name: icon, size: 22 }),
                children)))));
    }
    else {
        return (isolateComponent(WrapperElement, { css: Styles.root(true), "data-position": position, "data-testid": "topbar-link", role: role },
            isolateComponent("button", { css: Styles.link(true), "data-text": children, "data-selected": isMenuOpen, onClick: () => {
                    handleEvent('click');
                    if (toggleMenu)
                        toggleMenu();
                }, onMouseEnter: () => handleEvent('hover'), "aria-controls": sanitizedId, "aria-expanded": isMenuOpen },
                isolateComponent("span", { css: Styles.linkInner(true) },
                    children,
                    isolateComponent("span", { css: Styles.caret(isMenuOpen) },
                        isolateComponent(Icon, { isBlock: true, name: "arrowSmallDown", size: 16 })))),
            isolateComponent(MegaMenu, { id: sanitizedId || '', isMenuOpen: isMenuOpen || false, key: (isMenuOpen || 'false').toString(), navigationItem: navigationItem, onCloseMenu: onCloseMenu })));
    }
};
export default UniversalTopbarLink;
//# sourceMappingURL=UniversalTopbarLink.js.map
// @zapier/universal-layout@8.11.3 (3d6dc537c)
